import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, IconButton } from '@material-ui/core';
import { CloseIcon } from '../../Icon';
import Login from './Base';

const useStyles = makeStyles((theme) => ({
  popover: {
    background: '#cccccc66',
    '& .MuiPopover-paper': {
      background: 'transparent',
      'box-shadow': '0 0',
    },
  },
  dialog: {
    '& .MuiPaper-rounded': {
      marginTop: '-2.5rem',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.393rem 0.75rem rgba(0, 0, 0, 0.04)',
    },
  },
  dialogIcon: {
    fontSize: '1rem',
    color: '#5f9df6',
    float: 'right',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  btn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
}));

export default function VerifyAccountPop({ open, onClose, successHandle, failHandle, corpId }) {
  const classes = useStyles();

  return (
    <div>
      <Dialog open={open} className={classes.dialog}>
        <Login
          successHandle={successHandle}
          button="Confirm"
          title="Verify your account"
          corpId={corpId}
          failHandle={failHandle}
        >
          <div className={classes.btn}>
            <IconButton
              style={{
                margin: '0px -10px 0 0',
              }}
              onClick={onClose}
            >
              <CloseIcon className={classes.dialogIcon} />
            </IconButton>
          </div>
        </Login>
      </Dialog>
    </div>
  );
}
